// src/utils/formatTimestamp.js

function toTimestampMs(value) {
  if (value == null || value === "") return NaN;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d+$/.test(trimmed)) {
      const n = Number(trimmed);
      return trimmed.length === 10 ? n * 1000 : n;
    }
    return Date.parse(trimmed);
  }

  const n = Number(value);
  if (Number.isNaN(n)) return NaN;
  return String(Math.trunc(n)).length === 10 ? n * 1000 : n;
}

/**
 * Formats a timestamp into "10 Dec 2020" format.
 * @param {number} timestamp - The timestamp in seconds or milliseconds.
 * @returns {string} - Formatted date string.
 */
export function formatTimestamp(timestamp) {
    // Convert timestamp to a number if it's not already
    if (typeof timestamp === 'string') {
      timestamp = Number(timestamp);
    }
  
    // Check if the timestamp is in seconds (10 digits) and convert to milliseconds
    if(timestamp){
      if (timestamp.toString().length === 10) {
        timestamp *= 1000;
      }
    
      // Validate the timestamp range
      const minValidDate = new Date(-8640000000000000); // Earliest possible date in JavaScript
      const maxValidDate = new Date(8640000000000000);  // Latest possible date in JavaScript
      const date = new Date(timestamp);
    
      if (isNaN(date) || date < minValidDate || date > maxValidDate) {
        throw new Error("Invalid timestamp provided");
      }
    
      // Format the date
      const options = { day: '2-digit', month: 'short', year: 'numeric' };
      return date.toLocaleDateString('en-US', options).replace(',', '');
    }else{
      return 'undefined'
    }
   
  }




  export function formatTimestampUtc(startDate) {
    // Split the date string into components
    const [year, month, day] = startDate.split('-').map(num => parseInt(num, 10));
    // Create date using local components to avoid timezone issues
    const date = new Date(year, month - 1, day);
    
    return date.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(',', '');
  }
  
  /**
   * Formats a timestamp into 12-hour time with AM/PM.
   * @param {number} timestamp - The timestamp in seconds or milliseconds.
   * @returns {string} - Formatted time string.
   */
  export function formatTime(timestamp) {
    // Convert timestamp to a number if it's not already
    if (typeof timestamp === 'string') {
      timestamp = Number(timestamp);
    }
  
    // Check if the timestamp is in seconds (10 digits) and convert to milliseconds
    if (timestamp.toString().length === 10) {
      timestamp *= 1000;
    }
  
    // Validate and parse the timestamp
    const date = new Date(timestamp);
    if (isNaN(date)) {
      throw new Error("Invalid timestamp provided");
    }
  
    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 -> 12)
  
    // Format time
    const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    return formattedTime;
  }
  


  export function formatTimestampForZone(timestamp) {
   let timeZone = JSON.parse(localStorage.getItem('organization')).org_timezone.S
    timestamp = toTimestampMs(timestamp);
  
    if (Number.isNaN(timestamp)) {
      throw new Error("Invalid timestamp provided");
    }
  
    const date = new Date(timestamp);
  
    // Define options for the date formatter
    const dateOptions = {
      timeZone,
      month: "short", // Abbreviated month
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // 12-hour format with AM/PM
    };
  
    // Format the date and time
    const formatter = new Intl.DateTimeFormat("en-US", dateOptions);
    return formatter.format(date).replace(",", "");
  }

  export function formatTimestampForZone2(timestamp) {
    let timeZone = JSON.parse(localStorage.getItem('organization')).org_timezone.S;
    
    // Ensure timestamp is a number if it's a string
    if (typeof timestamp === "string") {
      timestamp = Number(timestamp);
    }
  
    // Check if the timestamp is in seconds (10 digits) and convert to milliseconds
    if (timestamp.toString().length === 10) {
      timestamp *= 1000;
    }
  
    // Validate and parse the timestamp
    const date = new Date(timestamp);
    if (isNaN(date)) {
      throw new Error("Invalid timestamp provided");
    }
  
    // Convert the date to the specified time zone
    const options = {
      timeZone,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // 12-hour format with AM/PM
    };
  
    // Format the date for the target time zone
    const formatter = new Intl.DateTimeFormat("en-US", options);
    const formattedDate = formatter.format(date);
  
    // Return the date object in the format similar to `new Date(call.callTime * 1000)`
    return new Date(formattedDate);
  }
  
  let timezone = JSON.parse(localStorage.getItem('organization'))?.org_timezone?.S || null
  export function convertDateToTimezone(dateString) {
    const date = new Date(dateString); // Parse the input date
    const options = { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' };
  
    // Use Intl.DateTimeFormat to format the date in the target timezone
    const formatter = new Intl.DateTimeFormat('en-CA', options); // en-CA ensures YYYY-MM-DD format
    const parts = formatter.formatToParts(date);
  
    const year = parts.find(part => part.type === 'year').value;
    const month = parts.find(part => part.type === 'month').value;
    const day = parts.find(part => part.type === 'day').value;
  
    return `${year}-${month}-${day}`;
  }
  